import { useQuery } from '@tanstack/react-query'
import type { SettingDef } from '@project/contracts'
import { Lookup, Select } from '../../design/index.js'
import { useApi } from '../../app/api.js'

/**
 * A setting that names a record (SET-006): the Default Labour item is picked
 * from the items, the exception approver from the roles. A role is stored by
 * its code, which is what the approval stage is bound to; anything else by id.
 */
export const SettingLookup = ({ def, value, busy, onSave }: {
  def: SettingDef
  value: string
  busy: boolean
  onSave: (value: string) => void
}) => {
  const api = useApi()
  const entity = def.lookup?.entity ?? ''
  const byCode = def.lookup?.valueField === 'code'
  const options = useQuery({
    queryKey: ['masterList', api.companyId, entity],
    queryFn: () => api.masterList(entity, { pageSize: '200' }),
    enabled: byCode,
    staleTime: 60_000,
  })
  const label = useQuery({
    queryKey: ['lookupNames', api.companyId, entity, value],
    queryFn: async () => {
      const rows = await api.send<ReadonlyArray<{ id: string; label: string | null }>>(
        `/lookups/${encodeURIComponent(entity)}?id=${encodeURIComponent(value)}`,
      )
      return rows.find((r) => r.id === value)?.label ?? null
    },
    enabled: !byCode && value !== '',
    staleTime: 60_000,
  })

  if (byCode) {
    return (
      <div style={{ width: 260 }}>
        <Select
          value={value}
          placeholder="Nobody named"
          aria-label={def.label}
          disabled={busy}
          onChange={onSave}
          options={(options.data?.rows ?? []).map((r) => ({ value: String(r['code'] ?? ''), label: String(r['name'] ?? r['code'] ?? '') }))}
        />
      </div>
    )
  }
  return (
    <div style={{ width: 300 }} aria-label={def.label}>
      <Lookup
        entity={entity}
        value={value}
        {...(label.data ? { label: label.data } : {})}
        placeholder={`Search ${entity.replace(/_/g, ' ')}s`}
        disabled={busy}
        onChange={(id) => onSave(id)}
      />
    </div>
  )
}
